import { categories, contactEmail, siteName, siteTagline } from "@/mocks/works";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-800 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 ring-1 ring-background-50/20">
                <i className="ri-heart-3-fill text-accent-400 text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-50/75">{siteTagline}</p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-background-50/75">
              专注人妻动漫题材的推荐、盘点、排行与口碑精选平台，为同好省去筛选时间，每期更新优质内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-50/85">
                <i className="ri-shield-check-line text-accent-400" aria-hidden="true"></i>
                口碑真实
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-50/85">
                <i className="ri-refresh-line text-accent-400" aria-hidden="true"></i>
                每期更新
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-50/85">
                <i className="ri-book-open-line text-accent-400" aria-hidden="true"></i>
                同好精选
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                ["#categories", "作品分类"],
                ["#ranking", "人气排行"],
                ["#recommend", "作品推荐"],
                ["#roundups", "专题盘点"],
                ["#reviews", "同好口碑"],
                ["#about", "关于我们"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="inline-flex items-center gap-1.5 text-sm text-background-50/75 hover:text-accent-300 transition-colors"
                  >
                    <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}>
                  <a
                    href="#recommend"
                    className="inline-flex items-center gap-1.5 text-sm text-background-50/75 hover:text-accent-300 transition-colors"
                  >
                    <i className="ri-flower-line" aria-hidden="true"></i>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href={`mailto:${contactEmail}`}
              className="mt-5 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              {contactEmail}
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-50/60">
            © 2026 {siteName} 版权所有 · 本站为独立内容推荐平台，作品版权归各原版权方所有
          </p>
          <a
            href="#home"
            className="inline-flex items-center gap-1.5 text-xs text-background-50/70 hover:text-accent-300 transition-colors"
          >
            回到顶部
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}